import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import WebSessionType from 'owa-service/lib/contract/WebSessionType';
import { isGeneratedAddress } from 'owa-client-ids/lib/utils/getDefaultRoutingKey';
import { isFeatureEnabled } from 'owa-feature-flags';
import { logUsage } from 'owa-analytics';
import { DatapointVariant } from 'owa-analytics-types';
import { getServerVersion } from 'owa-config';
import { isGreaterThanOrEqualTo } from '../utils/semverCompare';

export function isEasiIdUser() {
    if (
        !isFeatureEnabled('growth-easiIdGmailCloudCache') &&
        !isFeatureEnabled('growth-easiIdGmailCloudCacheV2')
    ) {
        return false;
    }

    // TODO: In order to guarantee that a required substrate fix is available for every user
    // accessing this feature, this bandage is being added so we can proceed with the EASI ID
    // experiment. Once this build version is 100% available WW, this verification can be removed.
    const substrateFixVersion = '15.20.4846.000';
    let serverVersion = getServerVersion();
    if (serverVersion && !isGreaterThanOrEqualTo(serverVersion, substrateFixVersion)) {
        return false;
    }

    if (isNonPremiumUserAccessingCloudCacheInbox()) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (31,55): Argument of type 'null' is not assignable to parameter of type 'CustomData | undefined'.
        // @ts-expect-error
        logUsage('nonPremiumUserAccessingCloudCache', null, {
            // this function is called more than once per session,
            // so we added this flag to log only the first datapoint
            variant: DatapointVariant.WarmOnly,
            isCore: true,
        });

        return false;
    }

    if (getUserConfiguration().SessionSettings?.WebSessionType != WebSessionType.ExoConsumer) {
        return false;
    }

    const emailAddress = getUserConfiguration().SessionSettings?.UserEmailAddress;
    const cid = getUserConfiguration().HexCID?.toUpperCase();

    // match returns null if the string does not match the pattern
    if (!emailAddress || !cid || !isGeneratedAddress(cid, emailAddress)) {
        return false;
    }

    // For the initial stage, we are going to consider only Gmail users as valid EASI ID users
    if (!isGmailUser()) {
        return false;
    }

    return true;
}

function isNonPremiumUserAccessingCloudCacheInbox() {
    return (
        getUserConfiguration().SessionSettings?.IsShadowMailbox &&
        !getUserConfiguration().SessionSettings?.IsPremiumConsumerMailbox
    );
}

function isGmailUser() {
    const notManagedEmailAddresses = getUserConfiguration().SessionSettings
        ?.NotManagedEmailAddresses;

    if (
        !notManagedEmailAddresses ||
        notManagedEmailAddresses.length == 0 ||
        // we found that EasiId users have the first notManagedEmailAddresses array item filled with the original email
        // So, we use that to validate if it's a Gmail user based on its value
        notManagedEmailAddresses[0].indexOf('@gmail.com') < 0
    ) {
        return false;
    }

    return true;
}
